import { render, staticRenderFns } from "./TipsDialog.vue?vue&type=template&id=5b1524e2&"
import script from "./TipsDialog.vue?vue&type=script&lang=js&"
export * from "./TipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TipsDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports